module.exports = __webpack_public_path__ + "static/media/rightLogo.d24890a3.png";